<template>
  <component :is="tag" class="icon typo-icon-14 text-light-disabled clickable weight-800" :class="[icon, iClass]" v-popover="{ name: 'tooltip', disabled: !hasTooltip, value: tooltipText, position: position, delay: delay }">
  </component>
</template>

<script>
export default {
  name: "Icon",
  props: {
    icon: {
      type: String,
      default: "icon-help"
    },
    iClass: String,
    hasTooltip: {
      type: Boolean,
      default: false
    },
    tooltipText: {
      type: String,
      default: "Just a free text"
    },
    tooltipDirection: {
      type: String,
      default: "bottom"
    },
    tag: {
      type: String,
      default: "i"
    },
    position: {
      type: String,
      default: "bottom"
    },
    delay: {
      type: Number,
      default: 800
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.icon {
  &:hover {
    @include trans-all;
    color: $textLightModeHigh !important;
  }
}
</style>
